const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyGlass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.437,
    height: 90.915,
    viewBox: "0 0 16.255 24.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79ccce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 7.809-60.884c0-1.608 6.817-2.912 15.228-2.912s15.232 1.304 15.232 2.912L46.078 0z",
    transform: "matrix(.35278 0 0 -.35278 0 1.549)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61bcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 2.424-10.317 4.39-23.041 4.39S-46.078 2.424-46.078 0c0-2.423 10.313-4.389 23.037-4.389C-10.317-4.389 0-2.423 0 0",
    transform: "matrix(.35278 0 0 -.35278 16.255 1.549)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGlass);
export default __webpack_public_path__ + "static/media/empty_glass.9d2efee44845ef082925c2c7bf4655a3.svg";
export { ForwardRef as ReactComponent };